// extracted by mini-css-extract-plugin
export default {"button":"my_button_button__78Mhp"};